module.exports = __webpack_public_path__ + "1bcd9a944635f01136b4cd7974b6e884.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/EU-logo.svg
// module id = 4tRb
// module chunks = 1